import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import once from '@mailobj-browser/front/js/events/options/once.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import input from '@mailobj-browser/front/js/events/types/input.js'
import load from '@mailobj-browser/front/js/events/types/load.js'
import selectionChange from '@mailobj-browser/front/js/events/types/selectionChange.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import { removed } from '@mailobj-browser/front/js/tree/tree.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import globals from '#utilities/js/ea/globals.js'
import { elements } from '../../../../styles.js'
import { actionCloseSwitch } from './mailModified.js'

const iframes = new WeakMap()

const modifiedIframe = object(listener, {
  passive,
  task: (
    contentDocument
  ) => {
    const form = closest('form', iframes.get(contentDocument))
    const msgModified = one(`input[name='msg_modified']`, form)

    if (form) {
      const topbar = one(`.${elements.send_topbar}`, form)

      if (msgModified) {
        globals.ea_msg_mail_modified()
        msgModified.value = '1'
        globals.ea_link_alert_tst.push('ea_rte_update(\'id_msg_text\')')
      }

      if (topbar) {
        actionCloseSwitch(topbar)
      }
    }
  }
})

const onInput = object(modifiedIframe, {
  type: input
})

const onSelectionChange = object(modifiedIframe, {
  type: selectionChange
})

const onLoad = object(listener, {
  type: load,
  passive,
  once,
  task: (
    iframe
  ) => {
    const { contentDocument } = iframe

    if (!iframes.has(contentDocument)) {
      iframes.set(contentDocument, iframe)
    }

    onInput.listen(contentDocument)
    onSelectionChange.listen(contentDocument)

    queueMicrotask(async () => {
      await removed(iframe)
      if (iframes.get(contentDocument) === iframe) {
        iframes.delete(contentDocument)
      }
    })
  }
})

export default iframe => {
  const { contentWindow } = iframe

  if (contentWindow) {
    return onLoad.task(iframe)
  }

  onLoad.listen(iframe)
}